import {Component, OnInit} from '@angular/core';
import {UploadProgressService} from './upload-progress.service';

@Component({
  selector: 'app-upload-progress-popup',
  templateUrl: './upload-progress-popup.component.html',
  styleUrls: ['./upload-progress-popup.component.scss'],
})
export class UploadProgressPopupComponent implements OnInit {
  progress: number = 0;
  filename: string = '';

  constructor(private uploadProgressService: UploadProgressService) {}

  ngOnInit(): void {
    this.uploadProgressService.progress$.subscribe((progress) => {
      this.progress = progress;
    });

    this.uploadProgressService.filename$.subscribe((filename) => {
      this.filename = filename;
    });
  }

  closePopup(): void {
    this.uploadProgressService.closePopup();
  }
}
